import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import { postMeetingApplication } from '../../../api/MeetingApplicationApi';
import useLoadingStore from '../../../store/loadingStore';
import { AlertModal } from '../../layouts/AlertModal'; // AlertModal import
import { ConfirmModal } from '../../layouts/ConfirmModal';

const MeetingApplicationFormPage = () => {
    const { meetingId } = useParams();
    const navigate = useNavigate();
    const { setIsLoading } = useLoadingStore();
    const [content, setContent] = useState('');

    // 모달 상태 관리
    const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });
    const [confirmState, setConfirmState] = useState({ isVisible: false });

    const getErrorMessage = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        }
        return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
    };

    const handleSubmit = () => {
        if (!content.trim()) {
            setAlertState({ isVisible: true, message: '소개글을 입력해주세요.' });
            return;
        }
        setConfirmState({ isVisible: true });
    };

    const handleConfirmSubmit = async () => {
        try {
            setIsLoading(true);
            await postMeetingApplication(meetingId, { content: content.trim() });
            setAlertState({
                isVisible: true,
                message: '모임 참가 신청이 완료되었습니다.',
                callback: () => navigate('/app/meetings', { replace: true })
            });
        } catch (error) {
            console.error('모임 신청 실패:', error);
            setAlertState({ isVisible: true, message: getErrorMessage(error) });
        } finally {
            setIsLoading(false);
            setConfirmState({ isVisible: false });
        }
    };

    const isFormValid = content.trim();

    return (
        <CommonLayout title="모임 참가 신청">
            <ConfirmModal
                isVisible={confirmState.isVisible}
                title="모임 참가 신청"
                message={'정말로 모임 참가 신청을 하시겠습니까?\n 쌀 500알이 차감됩니다'}
                onConfirm={handleConfirmSubmit}
                onCancel={() => setConfirmState({ isVisible: false })}
            />
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
            />
            <div className="max-w-lg mx-auto">
                <div className="p-4 space-y-6">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <p className="text-sm text-blue-700">
                            모임장이 신청서를 검토한 후 승인 여부를 결정합니다.
                        </p>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            소개글 <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            placeholder="자기소개나 모임 참여 이유를 간단히 작성해주세요 (최대 100자)"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            maxLength={100}
                            rows={5}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 resize-none"
                        />
                        <p className="text-xs text-gray-500 text-right mt-1">{content.length}/100</p>
                    </div>

                    <div className="space-y-3">
                        <button
                            onClick={handleSubmit}
                            disabled={!isFormValid}
                            className={`w-full py-4 rounded-lg font-medium transition-colors ${
                                isFormValid
                                    ? 'bg-amber-500 text-white active:bg-amber-600'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            참가 신청
                        </button>

                        <button
                            onClick={() => navigate(-1)}
                            className="w-full py-4 bg-gray-100 text-gray-700 rounded-lg font-medium active:bg-gray-200 transition-colors"
                        >
                            취소
                        </button>
                    </div>
                </div>
            </div>
        </CommonLayout>
    );
};

export default MeetingApplicationFormPage;
